import { render, staticRenderFns } from "./home-second.vue?vue&type=template&id=5d0bbbe8&lang=pug&"
import script from "./home-second.vue?vue&type=script&lang=js&"
export * from "./home-second.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports